import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import LoginPage from "./pages/auth/Login";
import PrivateLayout from "./layouts/PrivateLayout";
import DashboardPage from "./pages/Dashboard";
import UserManagement from "./pages/UserManagement";
import SettingsPage from "./pages/Settings";
import AppState from "./context/AppState";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Report from "./pages/Report/Report";
import Logs from "./pages/Logs";
import HelpDesk from "./pages/helpdesk";
import Assets from "./pages/assets";
import { useContext, useEffect, useState } from "react";
import AppContext from "./context/AppContext";
import axios from "axios";
import AssetReportDetail from "./pages/Report/AssetReportDetail";
import io from "socket.io-client";
import GatewayDetails from "./pages/Report/GatewayDetails";
import SignIn from "./pages/auth/SignIn";
import UsersManagment from "./pages/UsersManagment";

function PrivateRoute({ children, ...rest }) {
  const {
    setCategory,
    setAsset,
    setLocation,
    setLoadingAssets,
    setGateway,
    setSocketData,
    setUserRole,
    setNotification,
    setLoading,
  } = useContext(AppContext);

  const [socket, setSocket] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    // const socket = io(`${process.env.REACT_APP_SOCKET_URL}:3010`);
    const socket = io(`https://socket.coredataworld.com:3010`);
    setSocket(socket);

    // Listen to events from the socket
    socket.on("new_data", (receivedData) => {
      if (receivedData) setSocketData(receivedData);
    });

    // Clean up function to close the socket connection when component unmounts
    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/asset/notification`
        );
        if (response.data.status === "success") {
          setNotification(response.data.not_received);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    const interval = setInterval(fetchData, 20000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setLoadingAssets(true);
      try {
        const categoryResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/assets/categories`
        );
        //  const categoryResponse = await axios.get(`http://localhost:5002/api/v1/beacon/get/assets/categories`);
        const assetResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/assets`
        );
        //  const assetResponse = await axios.get(`http://localhost:5002/api/v1/beacon/get/assets`);
        const locationResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/location`
        );
        //  const locationResponse = await axios.get(`http://localhost:5002/api/v1/beacon/get/location`);
        const gatewayResponse = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/beacon/get/gateway`
        );
        //  const gatewayResponse = await axios.get(`http://localhost:5002/api/v1/beacon/get/gateway`);

        if (categoryResponse.data.status === "success") {
          setCategory(categoryResponse.data.category);
        }

        if (assetResponse.data.status === "success") {
          setLoadingAssets(false);
          setAsset(assetResponse.data.assets);
        }

        if (locationResponse.data.status === "success") {
          setLoading(false);
          setLocation(locationResponse.data.data);
        }

        if (gatewayResponse.data.status === "success") {
          setGateway(gatewayResponse.data.data);
          setLoading(false);
        }
      } catch (error) {
        // Handle error
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // const { currentUser } = useAuth();

  // currentUser?.getIdTokenResult().then((idTokenResult) => {

  // if (!!idTokenResult.claims.superAdmin) {

  //   setUserRole("superAdmin");
  // } else if(!!idTokenResult.claims.admin) {

  //   setUserRole("admin");
  // }
  // else{
  //     setUserRole("napino");
  // }
  // });

  const { currentUser } = useAuth();
  const user = localStorage.getItem("user");
  currentUser?.getIdTokenResult().then((idTokenResult) => {
    let userRole = "napino"; // Default role

    if (!!idTokenResult.claims.superAdmin) {
      userRole = "superAdmin";
    } else if (!!idTokenResult.claims.admin) {
      userRole = "admin";
    } else if (!!idTokenResult.claims.demo) {
      userRole = "demo";
    }

    setUserRole(userRole);
    localStorage.setItem("userRole", userRole);
  });

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          <PrivateLayout>{children}</PrivateLayout>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

// function AuthRoute({ children, ...rest }) {
//    setInterval(() => {

//    }, 1000);
//   const user = localStorage.getItem('user');

// return (
//   <Route
//     {...rest}
//     render={({ location }) =>
//       user ? (
//         <Redirect
//           to={{
//             pathname: '/dashboard',
//             state: { from: location },
//           }}
//         />
//       ) : (
//         children
//       )
//     }
//   />
// );
// }

function AuthRoute({ children, ...rest }) {
  const [user, setUser] = useState(localStorage.getItem("user"));
  const history = useHistory();

  useEffect(() => {
    // Function to check for user in localStorage
    const checkUser = () => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUser(storedUser);
        history.push("/dashboard");
        clearInterval(interval); // Clear interval once user is found
      }
    };

    // Set an interval to check for user every second (1000ms)
    const interval = setInterval(checkUser, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [history]);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        !user
          ? children
          : // The user exists, redirect to dashboard
            history.push("/dashboard")
      }
    />
  );
}

function RedirectHandler() {
  const user = localStorage.getItem("user");
  return <Redirect to={user ? "/dashboard" : "/"} />;
}

function App() {
  return (
    <AppState>
      <AuthProvider>
        <BrowserRouter>
          <Switch>
            <AuthRoute exact path="/">
              <SignIn />
            </AuthRoute>
            {/* <AuthRoute exact path="/signin">
              <SignIn />
            </AuthRoute> */}
            <PrivateRoute exact path="/dashboard">
              <DashboardPage />
            </PrivateRoute>
            <PrivateRoute exact path="/settings">
              <SettingsPage />
            </PrivateRoute>
            <PrivateRoute exact path="/reports/gateway-id/:gateway_id">
              <GatewayDetails />
            </PrivateRoute>
            <PrivateRoute exact path="/reports">
              <Report />
            </PrivateRoute>
            <PrivateRoute exact path="/logs">
              <Logs />
            </PrivateRoute>
            <PrivateRoute exact path="/helpdesk">
              <HelpDesk />
            </PrivateRoute>
            <PrivateRoute exact path="/assets">
              <Assets />
            </PrivateRoute>
            <PrivateRoute exact path="/users_management">
              <UserManagement />
            </PrivateRoute>
            {/* <PrivateRoute exact path="/user_management">
              <UsersManagment/>
            </PrivateRoute> */}
            <PrivateRoute exact path="/reports/asset-name/:asset_name">
              <AssetReportDetail />
            </PrivateRoute>
            <RedirectHandler path="*"></RedirectHandler>
          </Switch>
        </BrowserRouter>
      </AuthProvider>
    </AppState>
  );
}

export default App;
